"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6071],{

/***/ 56071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AsymmetricSideBySideTextAndAssetComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js
var side_by_side_text_and_asset = __webpack_require__(59526);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/triangle-with-color/triangle-with-color.scss.js


var MAX_ASYMETRIC_DIV_HEIGHT = 180;
var MACBOOK_ASYMETRIC_DIV_HEIGHT = 116;
var MOBILE_ASYMETRIC_DIV_HEIGHT = 90;
var SMALL_MOBILE_ASYMETRIC_DIV_HEIGHT = 80;
var widthBorder = function() {
    return "50vw solid";
};
var heightBorder = function(divHeight) {
    return "".concat(divHeight / 2, "px solid");
};
var StyledTriangleWithColor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "edzjdqp0"
})("height:", MAX_ASYMETRIC_DIV_HEIGHT, "px;width:100%;border-right:", widthBorder(), ";border-left:", widthBorder(), ";border-bottom:", heightBorder(MAX_ASYMETRIC_DIV_HEIGHT), ";border-top:", heightBorder(MAX_ASYMETRIC_DIV_HEIGHT), ";@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){height:", MACBOOK_ASYMETRIC_DIV_HEIGHT, "px;border-bottom:", heightBorder(MACBOOK_ASYMETRIC_DIV_HEIGHT), ";border-top:", heightBorder(MACBOOK_ASYMETRIC_DIV_HEIGHT), ";}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){height:", MOBILE_ASYMETRIC_DIV_HEIGHT, "px;border-bottom:", heightBorder(MOBILE_ASYMETRIC_DIV_HEIGHT), ";border-top:", heightBorder(MOBILE_ASYMETRIC_DIV_HEIGHT), ";}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){height:", SMALL_MOBILE_ASYMETRIC_DIV_HEIGHT, "px;border-bottom:", heightBorder(SMALL_MOBILE_ASYMETRIC_DIV_HEIGHT), ";border-top:", heightBorder(SMALL_MOBILE_ASYMETRIC_DIV_HEIGHT), ";}");

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/triangle-with-color/default-props.js

/* harmony default export */ var default_props = ({
    color: colors/* default.brand-enterprise-dark */.Z["brand-enterprise-dark"]
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/triangle-with-color/triangle-with-color.js









var TriangleWithColor = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TriangleWithColor, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TriangleWithColor);
    function TriangleWithColor() {
        (0,_class_call_check/* default */.Z)(this, TriangleWithColor);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TriangleWithColor, [
        {
            key: "getStyle",
            value: function getStyle() {
                var color = this.props.color;
                return {
                    borderTopColor: colors/* default.white */.Z.white,
                    borderRightColor: color,
                    borderBottomColor: color,
                    borderLeftColor: colors/* default.white */.Z.white
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var style = this.getStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTriangleWithColor, {
                    className: "triangle-with-color",
                    style: style
                });
            }
        }
    ]);
    return TriangleWithColor;
}(react.PureComponent);

TriangleWithColor.defaultProps = default_props;

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/asymmetric-side-by-side-text-and-asset/asymmetric-side-by-side-text-and-asset-component.scss.js

var StyledAsymmetricSideBySideTextAndAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kjjo6q0"
})(".asymmetric-side-by-side-text-and-asset-content.side-by-side-content{padding-bottom:64px;}");

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/asymmetric-side-by-side-text-and-asset/asymmetric-side-by-side-text-and-asset-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var AsymmetricSideBySideTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AsymmetricSideBySideTextAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AsymmetricSideBySideTextAndAssetComponent);
    function AsymmetricSideBySideTextAndAssetComponent() {
        (0,_class_call_check/* default */.Z)(this, AsymmetricSideBySideTextAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AsymmetricSideBySideTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, theme = _this_props.theme, restProps = _object_without_properties(_this_props, [
                    "theme"
                ]);
                var background = {
                    color: theme,
                    width: "100%"
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAsymmetricSideBySideTextAndAssetComponent, {
                    className: "asymmetric-side-by-side-text-and-asset-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TriangleWithColor, {
                            color: segments_service/* themes */.np[theme].background
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, _object_spread_props(_object_spread({}, restProps), {
                            background: background,
                            contentClassName: "asymmetric-side-by-side-text-and-asset-content"
                        }))
                    ]
                });
            }
        }
    ]);
    return AsymmetricSideBySideTextAndAssetComponent;
}(react.PureComponent);

AsymmetricSideBySideTextAndAssetComponent.defaultProps = _object_spread_props(_object_spread({}, side_by_side_text_and_asset/* default.defaultProps */.Z.defaultProps), {
    theme: "enterprise",
    titleSize: sizes.MD,
    textSize: sizes.MD
});


/***/ })

}]);